export default __webpack_public_path__ + "static/media/assets-film_00.40c4f22f.jpg";